/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_temp_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absolute zero is −273.15°C (0 K), the temperature at which atoms hold the minimum possible thermal energy. It's a physical floor, not just a low number — there's no such thing as 'colder than no motion at all,' which is why Kelvin values are never negative.`)
};

const es_uc_temp_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El cero absoluto es −273.15°C (0 K), la temperatura a la cual los átomos sostienen la energía térmica mínima posible. Es un piso físico, no solo un número bajo — no hay tal cosa como 'más frío que sin movimiento en absoluto,' por eso los valores de Kelvin nunca son negativos.`)
};

const de_uc_temp_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der absolute Nullpunkt liegt bei −273.15°C (0 K), der Temperatur, bei der Atome die minimal mögliche thermische Energie besitzen. Das ist eine physikalische Untergrenze, nicht nur eine niedrige Zahl — es gibt kein 'kälter als überhaupt keine Bewegung', weshalb Kelvin-Werte nie negativ sind.`)
};

const nl_uc_temp_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absoluut nul is −273,15°C (0 K), de temperatuur waarin atomen de minimaal mogelijke thermische energie vasthouden. Het is een fysieke ondergrens, niet slechts een laag getal — er is zoiets niet als 'kouder dan geen beweging helemaal,' wat is waarom Kelvin-waarden nooit negatief zijn.`)
};

const fr_uc_temp_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le zéro absolu est −273,15°C (0 K), la température à laquelle les atomes ont l'énergie thermique minimale possible. C'est un plancher physique, pas juste un nombre bas — il n'y a aucune chose comme 'plus froid que pas de mouvement du tout', c'est pourquoi les valeurs Kelvin ne sont jamais négatives.`)
};

const it_uc_temp_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo zero assoluto è −273,15°C (0 K), la temperatura alla quale gli atomi mantengono l'energia termica minima possibile. È un pavimento fisico, non solo un numero basso — non c'è una cosa come 'più freddo che non muoversi affatto,' che è il motivo per cui i valori Kelvin non sono mai negativi.`)
};

const pt_br2_uc_temp_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zero absoluto é −273.15°C (0 K), a temperatura na qual os átomos têm a energia térmica mínima possível. É um piso físico, não apenas um número baixo — não existe 'mais frio do que nenhum movimento', que é por que valores Kelvin nunca são negativos.`)
};

const pt_uc_temp_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zero absoluto é −273,15°C (0 K), a temperatura na qual os átomos mantêm a energia térmica minimamente possível. É um limite físico, não apenas um número baixo — não existe tal coisa como 'mais frio do que nenhum movimento de todo', que é porque os valores Kelvin nunca são negativos.`)
};

const ja_uc_temp_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`絶対零度は−273.15°C(0 K)で、原子が最小限の可能な熱エネルギーを保持する温度です。これは低い番号ではなく、物理的な床です — 「動きがないより冷たい」ことはできません。これがケルビンの値が決して負の理由です。`)
};

const zh_uc_temp_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_temp_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_temp_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_temp_faq3_a", locale)
	if (locale === "en") return en_uc_temp_faq3_a(inputs)
	if (locale === "es") return es_uc_temp_faq3_a(inputs)
	if (locale === "de") return de_uc_temp_faq3_a(inputs)
	if (locale === "nl") return nl_uc_temp_faq3_a(inputs)
	if (locale === "fr") return fr_uc_temp_faq3_a(inputs)
	if (locale === "it") return it_uc_temp_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_temp_faq3_a(inputs)
	if (locale === "pt") return pt_uc_temp_faq3_a(inputs)
	if (locale === "ja") return ja_uc_temp_faq3_a(inputs)
	return zh_uc_temp_faq3_a(inputs)
};